// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import styles from './office_location_banner.module.less';

const MAP_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3372.905055742516!2d34.86274911550902!3d32.28753051608818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d3f80e0be971d%3A0x2599f268a80d62e4!2sHaMahshev%20St%204%2C%20Netanya!5e0!3m2!1sen!2sil!4v1676569655787!5m2!1sen!2sil';

export const Office_location_banner = ()=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.location}>
      <div className={styles.address}>
        <p className={cn(theme.p2, theme.bold)}>Our office</p>
        <p className={cn(theme.p3, theme.reg, styles.address_text)}>
          4 Hamahshev St., Netanya 4250714, Israel <span>
          (POB 8025)</span><br/>
          Beit Ilan &mdash; Ground floor, Poleg Industrial Center<br/>
          Office Tel: +97298355993<br/>
          Support Email: <a className={styles.email}
            href="mailto:support@hola.org">support@hola.org</a>
        </p>
      </div>
      <div className={styles.map}>
        <iframe src={MAP_URL} width="100%" height="100%" style={{
          border: 'none',
        }}/>
      </div>
    </div>;
};

interface i_office_location_banner_editor_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const Office_location_banner_editor = (
{value, on_change}: i_office_location_banner_editor_props
)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
